import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBooking, setStep } from "../../../Reducer/bookingSlice";
import NextPrev from "../../../Helpers/Components/NextPrev"
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Components/Handler";

const Customer = (props) => {
    const booking = useSelector(state => state?.booking?.booking)
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const handleNext = async () => {
        if (!booking?.formNo) {
            toast.error("Form No. is required")
        } else {
            setLoading(true)
            const response = await Handler({ method: 'patch', data: { formNo: booking?.formNo }, url: `/booking/close/first/update/${props?.bookingId}` })
            setLoading(false)
            if (response?.success) {
                dispatch(setStep(1))
            } else {
                toast.error(response?.message);
            }
        }
    }
    const setSteps = () => {
        dispatch(setStep(1))
    }
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="formNo" className="form-label"> Form No </label>
                        <input name="formNo" id="formNo" autoComplete="off" disabled={loading} onChange={(e) => dispatch(setBooking({ formNo: e.target.value }))} className="form-control input-theme text-uppercase" value={booking?.formNo || ""} />
                    </div>
                </div>
            </div>
            <div className="row my-3">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="firstName" className="form-label">Customer Name </label>
                        <input readOnly name="firstName" id="firstName" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={(booking?.firstName || "") + " " + (booking?.lastName || "")} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div>Driving License: {booking?.customer?.kyc?.length ? booking?.customer?.kyc?.filter(element => element?.type === "dl")?.length ? booking?.customer?.kyc?.filter(element => element?.type === "dl")[0]?.id : "-" : "-"}</div>
                    <div> Driving License Date: {booking?.customer?.kyc?.length ? booking?.customer?.kyc?.filter(element => element?.type === "dl")?.length ? booking?.customer?.kyc?.filter(element => element?.type === "dl")[0]?.detail?.validTo : "-" : "-"} </div>
                    <div> Mobile Number: {booking?.customer?.phone?.length ? booking?.customer?.phone?.filter(element => element?.priority === 1)?.length ? ((booking?.customer?.phone?.filter(element => element?.priority === 1)[0]?.code || "") + "-" + (booking?.customer?.phone?.filter(element => element?.priority === 1)[0]?.phone || "")) : "-" : "-"} </div>
                    <div> Alternate Number : {booking?.customer?.phone?.length ? booking?.customer?.phone?.filter(element => element?.priority === 2)?.length ? ((booking?.customer?.phone?.filter(element => element?.priority === 2)[0]?.code || "") + "-" + (booking?.customer?.phone?.filter(element => element?.priority === 2)[0]?.phone || "")) : "-" : "-"} </div>
                    <div> Alternate Number 2 : {booking?.customer?.phone?.length ? booking?.customer?.phone?.filter(element => element?.priority === 3)?.length ? ((booking?.customer?.phone?.filter(element => element?.priority === 3)[0]?.code || "") + "-" + (booking?.customer?.phone?.filter(element => element?.priority === 3)[0]?.phone || "")) : "-" : "-"} </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="carId" className="form-label"> Car ID </label>
                        <input name="carId" id="carId" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.car?.carId || ""} />
                    </div>
                </div>
            </div>
            <NextPrev step={0} setStep={setSteps} last={3} onClick={handleNext} loading={false} />
        </React.Fragment>
    )
}

export default Customer;